import React, { Component } from 'react';

import './Footer.scss';

import WechatLogoImage from './wechat-logo.png';
import WechatLogoImage2x from './wechat-logo@2x.png';
import WechatQRImage from './wechat-qr.png';
import WechatQRImage2x from './wechat-qr@2x.png';

class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-6 Footer-left">
              <div className="Footer-contact-us">Contact Us</div>
              <div className="Footer-info">
                <div>info@paragonone.com</div>
                <div>1-888-527-6888</div>
              </div>
            </div>
            <div className="col-6 Footer-right">
              <div>
                <img
                  src={WechatLogoImage}
                  srcSet={`${WechatLogoImage2x} 2x`}
                  alt="WeChat"
                />
                <img
                  className="Footer-wechat-qr"
                  src={WechatQRImage}
                  srcSet={`${WechatQRImage2x} 2x`}
                  alt="WeChat"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="Footer-copyright">
                © 2018 Paragon One, All Rights Reserved
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/routes/signup/layouts/Footer/index.js